import content from "../../data/content";
import CtaBanner from "../../components/CtaBanner";
import "./Contact.css";

const { contact } = content;

export default function Contact() {
  return (
    <div className="contact-page">
      <section className="contact-header">
        <p className="page-label">Contact</p>
        <h1 className="page-heading">{contact.heading}</h1>
        <p className="contact-sub">{contact.subheading}</p>
      </section>

      <section className="contact-section">
        <div className="contact-section__inner">
          <div className="contact-details">
            {contact.details.map((d, i) => (
              <div key={i} className="contact-detail">
                <span className="contact-detail__label">{d.label}</span>
                {d.url ? (
                  <a
                    href={d.url}
                    className="contact-detail__value contact-detail__link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {d.value}
                  </a>
                ) : (
                  <span className="contact-detail__value">{d.value}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
